import { createApp } from 'vue'
import App from './App.vue'
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENABLE_PWA === 'true') {
  require('./registerServiceWorker')
}
import router from './router'
import store from './store'

createApp(App).use(store).use(router).mount('#app')
